import React from 'react';

export function PanelIconButton({ children, type = 'button', ...rest }) {
  const { className = '', ...buttonProps } = rest;
  return (
    <button className={`ci-icon-button ${className}`.trim()} type={type} {...buttonProps}>
      {children}
    </button>
  );
}
